import {BrickWall, Crosshair, DoorOpen, MapPinPlus, MousePointer2, Ruler, Sun, Waypoints} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";
import {availableEditorTools, editorToolLabels, type UnifiedEditorTool} from "./UnifiedEditorTools.ts";

const icons: Record<UnifiedEditorTool, typeof Ruler> = {
    select: MousePointer2,
    wall: BrickWall,
    door: DoorOpen,
    transition: Waypoints,
    annotation: MapPinPlus,
    light: Sun,
    calibrate: Ruler,
    origin: Crosshair,
};

export default function UnifiedEditorToolbar({tool, document, onSelectTool}: {
    tool: UnifiedEditorTool;
    document: LevelGeometryDocument;
    onSelectTool: (tool: UnifiedEditorTool) => void;
}) {
    const tools = availableEditorTools(document);
    return <nav aria-label="Dungeon-Werkzeuge"
        className="pointer-events-auto absolute bottom-4 left-1/2 z-20 flex max-w-[calc(100%-2rem)] -translate-x-1/2 items-center gap-1 rounded-xl border bg-card/95 p-1.5 shadow-xl backdrop-blur-sm">
        {tools.map((value, index) => {
            const Icon = icons[value];
            const separated = index > 0 && (value === "wall" || value === "calibrate");
            return <div key={value} className="flex shrink-0 items-center gap-1">
                {separated && <span aria-hidden="true" className="mx-1 h-6 w-px bg-border"/>}
                <Button type="button" size="icon" variant={tool === value ? "secondary" : "ghost"}
                    title={editorToolLabels[value]} aria-label={editorToolLabels[value]}
                    aria-pressed={tool === value} onClick={() => onSelectTool(value)}>
                    <Icon/>
                </Button>
            </div>;
        })}
    </nav>;
}
